import React, { useState, useEffect, useCallback } from 'react';
import { PublicHTTPService } from '../../../services/publicHttpService';
import JobviousLogo from "./../../../assets/Jobvious_logo@2x.svg";

const API = new PublicHTTPService();


const ReferralClaimForm = () => {
  const [step, setStep] = useState('loading');
  const [referralData, setReferralData] = useState(null);
  const [formData, setFormData] = useState({
    specialist_name: '',
    specialist_phone: '',
    specialist_email: '',
    specialist_business: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [emailSentTo, setEmailSentTo] = useState('');

  // Extract referral and token from URL params
  const urlParams = new URLSearchParams(window.location.search);
  const referralId = urlParams.get('referral');
  const claimToken = urlParams.get('token');

const validateClaim = useCallback(async () => {
  try {
    console.log('Validating claim with referralId:', referralId, 'and claimToken:', claimToken);
    const response = await API.get(`/claimreferral?referral=${referralId}&token=${claimToken}`);
    
    console.log('Returned Referral data:', response);

    let data = response.data
    
    if (data.success) {
      setReferralData(data.referral_preview);
      setStep('preview');
    } else {
      setStep('error');
    }
  } catch (error) {
    console.error('Error validating claim:', error);
    setStep('error');
  }
}, [referralId, claimToken]);

  useEffect(() => {
    if (!referralId || !claimToken) {
      setStep('error');
      return;
    }
    
    validateClaim();
  }, [referralId, claimToken, validateClaim]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.specialist_name.trim()) {
      newErrors.specialist_name = 'Name is required';
    }
    
    if (!formData.specialist_email.trim()) {
      newErrors.specialist_email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.specialist_email)) {
      newErrors.specialist_email = 'Please enter a valid email address';
    }
    
    if (!formData.specialist_phone.trim()) {
      newErrors.specialist_phone = 'Phone number is required';
    } else if (!/^[+]?[1]?[\s\-.]?[(]?[0-9]{3}[)]?[\s\-.]?[0-9]{3}[\s\-.]?[0-9]{4}$/.test(formData.specialist_phone)) {
      newErrors.specialist_phone = 'Please enter a valid phone number';
    }
    
    if (!formData.specialist_business.trim()) {
      newErrors.specialist_business = 'Business name is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClaimSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    console.log('Handle claim submit with referralId:', referralId, 'and claimToken:', claimToken);
    
    try {
      let payload = {
        ...formData,
        referral_id: referralId,
        claim_token: claimToken
      };

      const response = await API.post(`/claimreferral`, payload);

      console.log('Referral Response status:', response.status);

      const data = response.data;
      console.log('Customer Details Response:', data);
      if (data.success) {
        setCustomerDetails(data.customer_details);
        setEmailSentTo(data.email_sent_to || formData.specialist_email);
        setStep('success');
      } else {
        setErrors({ submit: data.message || 'Failed to claim referral. Please try again.' });
      }
    } catch (error) {
      console.error('Error claiming referral:', error);
      setErrors({ submit: 'Network error. Please check your connection and try again.' });
    } finally {
      setLoading(false);
    }
  };

  if (step === 'loading') {
    return (
      <div className="container-fluid min-vh-100 bg-light d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="spinner-border text-warning mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted">Validating referral...</p>
        </div>
      </div>
    );
  }

  if (step === 'error') {
    return (
      <div className="container-fluid min-vh-100 bg-light d-flex align-items-center justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-body text-center p-5">
              <div className="text-danger mb-4">
                <i className="fas fa-exclamation-triangle fa-3x"></i>
              </div>
              <h2 className="card-title mb-4">Invalid Referral Link</h2>
              <p className="text-muted mb-4">
                This referral link is invalid, expired, or has already been claimed by another specialist.
              </p>
              <a 
                href="https://jobvious.com" 
                className="btn btn-warning btn-lg"
              >
                Visit Jobvious.com
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (step === 'preview') {
    console.log('Rendering preview with referralData:', referralData);
    return (
      <div className="min-vh-100 bg-light">
        {/* Header */}
        <div className="bg-white shadow-sm">
          <div className="container py-4">
            <div className="d-flex align-items-center">
                            <img
                src={JobviousLogo}
                alt="Jobvious Logo"
                className="img-fluid"
                style={{ maxWidth: "200px", height: "auto" }}
              />

              <small className="text-muted ms-3">
                Bringing Car Dealers & Specialist Installers together
              </small>
            </div>
          </div>
        </div>

        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="card shadow">
                <div className="card-body p-5">
                  {/* Lead Preview */}
                  <div className="text-center mb-5">
                    <div className="text-success mb-3">
                      <i className="fas fa-check-circle fa-3x"></i>
                    </div>
                    <h1 className="h2 mb-3">Warm Customer Lead</h1>
                    <p className="text-muted">Customer already expressed interest • No cold calling required</p>
                  </div>

                  {/* Lead Details */}
                  <div className="bg-light rounded p-4 mb-5">
                    <h4 className="mb-4">Lead Details</h4>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Customer:</small>
                        <strong>{referralData?.customer_name}</strong>
                      </div>
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Service Requested:</small>
                        <strong>{referralData?.service_type}</strong>
                      </div>
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Location Area:</small>
                        <strong>{referralData?.location_area}</strong>
                      </div>
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Vehicle:</small>
                        <strong>{referralData?.vehicle_info}</strong>
                      </div>
                    </div>
                  </div>

                  {/* Claim Section */}
                  <div>
                    <h4 className="mb-4">Claim This Lead</h4>
                    <p className="text-muted mb-4">
                      Provide your contact information to claim this lead and get full customer details.
                    </p>

                    {errors.submit && (
                      <div className="alert alert-danger">
                        {errors.submit}
                      </div>
                    )}

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Your Name *</label>
                        <input
                          type="text"
                          name="specialist_name"
                          value={formData.specialist_name}
                          onChange={handleInputChange}
                          className={`form-control ${errors.specialist_name ? 'is-invalid' : ''}`}
                          placeholder="John Smith"
                        />
                        {errors.specialist_name && (
                          <div className="invalid-feedback">{errors.specialist_name}</div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Business Name *</label>
                        <input
                          type="text"
                          name="specialist_business"
                          value={formData.specialist_business}
                          onChange={handleInputChange}
                          className={`form-control ${errors.specialist_business ? 'is-invalid' : ''}`}
                          placeholder="Smith Auto Detailing"
                        />
                        {errors.specialist_business && (
                          <div className="invalid-feedback">{errors.specialist_business}</div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Phone Number *</label>
                        <input
                          type="tel"
                          name="specialist_phone"
                          value={formData.specialist_phone}
                          onChange={handleInputChange}
                          className={`form-control ${errors.specialist_phone ? 'is-invalid' : ''}`}
                          placeholder="(555) 123-4567"
                        />
                        {errors.specialist_phone && (
                          <div className="invalid-feedback">{errors.specialist_phone}</div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Email Address *</label>
                        <input
                          type="email"
                          name="specialist_email"
                          value={formData.specialist_email}
                          onChange={handleInputChange}
                          className={`form-control ${errors.specialist_email ? 'is-invalid' : ''}`}
                          placeholder="john@smithdetailing.com"
                        />
                        {errors.specialist_email && (
                          <div className="invalid-feedback">{errors.specialist_email}</div>
                        )}
                      </div>
                    </div>

                    <div className="mt-4">
                      <button
                        onClick={handleClaimSubmit}
                        disabled={loading}
                        className="btn btn-warning btn-lg w-100"
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Claiming Lead...
                          </>
                        ) : (
                          'Claim This Lead & Get Customer Details'
                        )}
                      </button>
                    </div>

                    <div className="mt-3 text-center">
                      <small className="text-muted">
                        By claiming this lead, you agree to contact the customer professionally and provide quality service.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (step === 'success') {
    return (
      <div className="min-vh-100 bg-light">
        {/* Header */}
        <div className="bg-white shadow-sm">
          <div className="container py-4">
            <div className="d-flex align-items-center">
              <img
                src={JobviousLogo}
                alt="Jobvious Logo"
                className="img-fluid"
                style={{ maxWidth: "200px", height: "auto" }}
              />
              <small className="text-muted ms-3">
                Bringing Car Dealers & Specialist Installers together
              </small>
            </div>
          </div>
        </div>

        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="card shadow">
                <div className="card-body p-5">
                  {/* Success Message */}
                  <div className="text-center mb-5">
                    <div className="text-success mb-3">
                      <i className="fas fa-check-circle fa-3x"></i>
                    </div>
                    <h1 className="h2 mb-3">Lead Claimed Successfully!</h1>
                    <p className="text-muted">Contact the customer below to get started on their project.</p>
                  </div>

                  {/* Customer Details */}
                  <div className="alert alert-info">
                    <h4 className="alert-heading mb-4">Customer Contact Information</h4>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Name:</small>
                        <strong>{customerDetails?.name}</strong>
                      </div>
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Phone:</small>
                        <strong>
                          <a href={`tel:${customerDetails?.phone}`} className="text-decoration-none">
                            {customerDetails?.phone}
                          </a>
                        </strong>
                      </div>
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Email:</small>
                        <strong>
                          <a href={`mailto:${customerDetails?.email}`} className="text-decoration-none">
                            {customerDetails?.email}
                          </a>
                        </strong>
                      </div>
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Service:</small>
                        <strong>{customerDetails?.service_requested}</strong>
                      </div>
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Location:</small>
                        <strong>{customerDetails?.location}</strong>
                      </div>
                      <div className="col-md-6 mb-3">
                        <small className="text-muted d-block">Vehicle:</small>
                        <strong>{customerDetails?.vehicle}</strong>
                      </div>
                    </div>
                  </div>

                  {/* Email Confirmation */}
                  {emailSentTo && (
                    <div className="alert alert-success">
                      <div className="d-flex align-items-center">
                        <div>
                          <strong>A copy of this information has been sent to:</strong><br />
                          {emailSentTo}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Next Steps */}
                  <div className="alert alert-warning">
                    <h4 className="alert-heading mb-4">Next Steps</h4>
                    <ol className="mb-0">
                      <li><strong>Contact within 24 hours</strong> - Customer is expecting your call</li>
                      <li><strong>Provide professional consultation</strong> - They already want the service</li>
                      <li><strong>Give accurate quote</strong> - Build trust with transparent pricing</li>
                      <li><strong>Complete quality work</strong> - Maintain our referral reputation</li>
                    </ol>
                  </div>

                  {/* Platform Invitation */}
                  <div className="border-top pt-4 text-center">
                    <h4 className="mb-3">Want More Leads Like This?</h4>
                    <p className="text-muted mb-4">
                      Join the Jobvious platform to get regular warm leads from dealerships in your area.
                    </p>
                    <a
                      href="https://jobvious.com"
                      className="btn btn-warning btn-lg"
                    >
                      Learn About Jobvious Platform
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ReferralClaimForm;